import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/search.svg'


_pushScopeId("data-v-6344e555")
const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "search",
  placeholder: "Buscar"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Buscar"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, _hoisted_4))
}